import type { TButtonDefault } from "types/buttons.type"
import style from "./ButtonOutline.module.scss"

const { button } = style

export const ButtonOutline = ({
	children,
	className = "",
	onClick,
	type = "button",
	submittable = true,
}: TButtonDefault) => {
	return (
		<button
			type={type}
			onClick={onClick}
			className={`${button} ${className}`}
			disabled={!submittable}
			data-testid="button-outline"
		>
			{children}
		</button>
	)
}
